// Confidence label for a model estimate, from its held-out error and sample
// size (DESIGN_SYSTEM §6 ConfidenceLabel). Thresholds are PROVISIONAL — to be
// recalibrated from the P3 walk-forward backtest — and deliberately coarse:
// three words a non-expert can act on, with the numbers one line below.

export type ConfidenceLevel = "high" | "medium" | "low";

export interface Confidence {
  level: ConfidenceLevel;
  label: string; // "High confidence"
  reason: string; // "±6% typical error on 214 recent sales"
}

export function confidenceOf(mapeOos: number | null | undefined, n: number): Confidence {
  const known = mapeOos != null && Number.isFinite(mapeOos);
  const err = known ? Math.round((mapeOos as number) * 100) : null;
  const level: ConfidenceLevel =
    known && (mapeOos as number) <= 0.06 && n >= 100 ? "high"
    : known && (mapeOos as number) <= 0.12 && n >= 30 ? "medium"
    : "low";
  const label = level === "high" ? "High confidence" : level === "medium" ? "Medium confidence" : "Low confidence";
  const reason = err != null
    ? `±${err}% typical error on ${n.toLocaleString()} recent sales`
    : `no held-out error yet · ${n.toLocaleString()} recent sales`;
  return { level, label, reason };
}
